// src/services/api.js
import axios from "axios";

// ایجاد یک نمونه از Axios با آدرس پایه بک‌اند جنگو (آدرس جدید سرور)
const api = axios.create({
  baseURL: "https://apiworks.devix.ir/api/", 
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;